import {
    BrowserRouter,
    Switch,
    Route
} from "react-router-dom";
import IleadTools from "../IleadTools";
import Protected from "./Protected";

const Router = () => {

    return (
        <BrowserRouter>
            <Switch>
                <Route exact path={'/admin/ilead-tools/:group?/:subgroup?/:title?'} component={Protected(IleadTools)}/>
                <Route exact path={'/project/:id/ilead/ilead-tools/:group?/:subgroup?/:title?'} component={Protected(IleadTools)}/>
            </Switch>
        </BrowserRouter>
    );
};

export default Router;